export const TEST_ID = 'droneCardHeader';
